/* dakotatin-attribution-cart.js
 * Writes captured attribution onto the active Shopify cart as note_attributes
 * via the AJAX cart API. Runs once per session. Idempotent.
 *
 * REQUIRES: dakotatin-attribution-capture.js (sets window.DTAttribution)
 *
 * On the resulting order in Shopify Admin you'll see:
 *   Additional details: gclid, utm_source, utm_medium, utm_campaign, ...
 * These are also queryable via the Admin API: order.note_attributes
 *
 * Created: 2026-05-28
 * Modified: 2026-05-28
 */
(function () {
  var SESSION_KEY = 'dt_attribution_written';
  if (sessionStorage.getItem(SESSION_KEY)) return;

  var attr = window.DTAttribution;
  if (!attr || !Object.keys(attr).length) return;

  var attributes = {};
  ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
    if (attr[k]) attributes[k] = attr[k];
  });
  if (!Object.keys(attributes).length) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  })
    .then(function () {
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    })
    .catch(function () {});
})();
